var _style, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatched(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0 {\n            fill: #327DFF;\n        }\n    ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9273 16.9273C18.1641 16.6906 18.1641 16.3066 17.9273 16.0699C17.6905 15.8331 17.3066 15.8331 17.0698 16.0699C16.833 16.3066 16.833 16.6906 17.0698 16.9273C17.3066 17.1641 17.6905 17.1641 17.9273 16.9273Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3345 4.22424C9.9897 3.90261 9.47321 3.9408 9.16358 4.25043L5.25043 8.16359C4.9408 8.47322 4.90261 8.98971 5.22424 9.33453C6.30073 10.4886 8.83432 12.5439 12.1255 13.3271L16.1477 18.2957L16.1668 18.3148C16.7695 18.9175 17.4405 19.0699 18.0352 18.9731C18.5981 18.8815 19.0549 18.5747 19.3148 18.3148C19.5747 18.0548 19.8815 17.598 19.9731 17.0352C20.0699 16.4404 19.9175 15.7694 19.3148 15.1668L19.2957 15.1477L14.3271 11.1255C13.5439 7.83431 11.4886 5.30073 10.3345 4.22424ZM9.76556 5.10138C10.8284 6.13884 12.5884 8.39017 13.3007 11.2525L12.2525 12.3007C9.39017 11.5884 7.13884 9.82838 6.10138 8.76557L9.76556 5.10138ZM13.9025 12.1036L18.6061 15.9113C18.9558 16.2703 19.0028 16.6016 18.9591 16.8701C18.9095 17.175 18.732 17.4446 18.5883 17.5883C18.4446 17.732 18.175 17.9095 17.8701 17.9591C17.6016 18.0028 17.2703 17.9558 16.9113 17.6061L13.1036 12.9025L13.9025 12.1036Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatched);
export default __webpack_public_path__ + "static/media/patched.727aacbdfbab939545b6024869ade9c7.svg";
export { ForwardRef as ReactComponent };